import AntIcon from '@ant-design/icons'
import { FC } from 'react'

export const Bell: FC = () => (
    <AntIcon
        component={() => (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12.0186 2.90967C8.70862 2.90967 6.01862 5.59967 6.01862 8.90967V11.7997C6.01862 12.4097 5.75862 13.3397 5.44862 13.8597L4.29862 15.7697C3.58862 16.9497 4.07862 18.2597 5.37862 18.6997C9.68862 20.1397 14.3386 20.1397 18.6486 18.6997C19.8586 18.2997 20.3886 16.8697 19.7286 15.7697L18.5786 13.8597C18.2786 13.3397 18.0186 12.4097 18.0186 11.7997V8.90967C18.0186 5.60967 15.3186 2.90967 12.0186 2.90967Z"
                    stroke="#528EFF"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                />
                <path
                    d="M13.8719 3.20043C13.5619 3.11043 13.2419 3.04043 12.9119 3.00043C11.9519 2.88043 11.0319 2.95043 10.1719 3.20043C10.4619 2.46043 11.1819 1.94043 12.0219 1.94043C12.8619 1.94043 13.5819 2.46043 13.8719 3.20043Z"
                    stroke="#528EFF"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.0195 19.0596C15.0195 20.7096 13.6695 22.0596 12.0195 22.0596C11.1995 22.0596 10.4395 21.7196 9.89953 21.1796C9.35953 20.6396 9.01953 19.8796 9.01953 19.0596"
                    stroke="#528EFF"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                />
            </svg>
        )}
    />
)
